module.exports = __webpack_public_path__ + "img/Schipper_a2.ac25812f.png";